// @ts-nocheck
"use client";

import Script from "next/script";
import { useStore } from "@/hooks/use-store";
import { useEffect } from "react";

export default function ChatSupport() {
  const { modal, modalSheet } = useStore();

  useEffect(() => {
    const chat = document.querySelector("jdiv");

    if (!chat) return;

    const visible = !(modal.activeModal || modalSheet.activeMenu);

    chat.style.display = visible ? "block" : "none";
  }, [modal.activeModal, modalSheet.activeMenu]);

  return (
    <Script id="jivo-chat" src="//code.jivo.ru/widget/4eyCUPm8Fg" strategy="afterInteractive" />
  );
}
